<template>
    <v-container>
        <v-row justify="center">
          <TakeBreakState></TakeBreakState>
        </v-row>
    </v-container>
</template>

<script>

    import TakeBreakState from "../../components/framework/general/TakeBreakState";
    export default {
        components: {
          TakeBreakState
        },
        props:{
          nextRoute:{
            type:Object
          }
        },
        name: "OnBreak",
        data: () => ({

        }),
        computed:{

        },
        created(){

        },
        methods:{
            start(){

            }
        }
    }
</script>

<style scoped>

</style>